export const EU_INSURANCE_COMPANIES = ['27EU', '25EU', '25MU', '24EU'] as const
